import { GraphConfig } from "./graph-config.d";

export const IR_GRAPH: GraphConfig = {
  margin: { top: 20, bottom: 40, left: 0, right: 0 },
  zoom: { enabled: true, min: 1, max: 1000 },
  axis: {
    x: {
      label: "",
      ticks: 7,
      tickSize: 7,
      tickFormat: ".4n",
      invert: true,
    },
    y: {
      label: "",
      ticks: 4,
      tickSize: 7,
      tickFormat: ".3n",
      invert: false,
      extent: [-10, 100],
    },
  },
};

export const NMR_GRAPH: GraphConfig = {
  margin: { top: 20, bottom: 40, left: 0, right: 0 },
  zoom: { enabled: true, min: 1, max: 1000 },
  axis: {
    x: {
      label: "",
      ticks: 7,
      tickSize: 7,
      tickFormat: ".3n",
      invert: true,
    },
    y: {
      label: "",
      ticks: 4,
      tickSize: 7,
      tickFormat: ".3n",
      invert: false,
    },
  },
};

export const MS_GRAPH: GraphConfig = {
  margin: { top: 20, bottom: 40, left: 0, right: 0 },
  zoom: { enabled: true, min: 1, max: 1000 },
  axis: {
    x: {
      label: "",
      ticks: 7,
      tickSize: 7,
      tickFormat: ".3n",
      invert: false,
    },
    y: {
      label: "",
      ticks: 8,
      tickSize: 7,
      tickFormat: "r",
      invert: false,
    },
  },
};

export const IR_PREVIEW_GRAPH: GraphConfig = {
  margin: { top: 8, bottom: 16, left: 0, right: 0 },
  zoom: { enabled: false },
  axis: {
    x: {
      label: "",
      ticks: 0,
      tickSize: 0,
      tickFormat: "",
      invert: true,
    },
    y: {
      label: "",
      ticks: 0,
      tickSize: 0,
      tickFormat: "",
      invert: false,
      extent: [-10, 100],
    },
  },
};

export const NMR_PREVIEW_GRAPH: GraphConfig = {
  margin: { top: 8, bottom: 16, left: 0, right: 0 },
  zoom: { enabled: false },
  axis: {
    x: {
      label: "",
      ticks: 0,
      tickSize: 0,
      tickFormat: "",
      invert: true,
    },
    y: {
      label: "",
      ticks: 0,
      tickSize: 0,
      tickFormat: "",
      invert: false,
      extent: [-5, 100],
    },
  },
};

export const MS_PREVIEW_GRAPH: GraphConfig = {
  margin: { top: 8, bottom: 0, left: 0, right: 0 },
  zoom: { enabled: false },
  axis: {
    x: {
      label: "",
      ticks: 0,
      tickSize: 0,
      tickFormat: "",
      invert: false,
    },
    y: {
      label: "",
      ticks: 0,
      tickSize: 0,
      tickFormat: "",
      invert: false,
    },
  },
};
